export default __webpack_public_path__ + "locales/de/PaymentsEnterprise.json?hash=f6e6f427f47ec9ece42fc209d9840ad1";